// nuxt-ui/Shared/composables/draftPlayers.ts

import type { AnyDraftPlayer } from "~/src/draft/domain/models/DraftPlayer";

interface UseDraftPlayers {
  getDraftPlayers: (
    draftId: number,
    playerRole: "player" | "goalkeeper"
  ) => Promise<AnyDraftPlayer[] | undefined>;
}

export const useDraftPlayers = (): UseDraftPlayers => {
  return {
    getDraftPlayers,
  };

  async function getDraftPlayers(
    draftId: number,
    playerRole: "player" | "goalkeeper"
  ): Promise<AnyDraftPlayer[] | undefined> {
    try {
      const path = `/api/v1/competition/drafts/${draftId}/${playerRole}`;
      const players = await $fetch<any>(path);

      if (players) {
        return players;
      } else {
        console.error("Fetched reserves is null");
      }
    } catch (e) {
      console.error("Error fetching reserves", e);
    }
  }
};
